import { Dialog, Icon } from 'ui';
import React from 'react';
import useDialogGlobalPost from './useDialogGlobalPost';

const DialogGlobalPost = () => {
  const { t, open, message, onClose } = useDialogGlobalPost();

  return (
    <Dialog
      title={
        <div className="dialog-global-post__header">
          <Icon name="megaphone" color="default" size="xl" /> <div className="dialog-global-post__header-title">{t('course:Global statement')}</div>
        </div>
      }
      isOpen={open}
      className={'dialog-global-post'}
      buttonTextSuccess={t('actions:Accept')}
      onClose={onClose}
      onSuccess={onClose}
      size="l"
    >
      <div className="dialog-global-post__message">{message}</div>
    </Dialog>
  );
};

export default DialogGlobalPost;
